<template>
  <div class="cashflow-type-economy card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>
    <expense-progress :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                      :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :blocked="true"/>

    <predicted-category-sections :initially-expanded="false"
                                 :title="titles.categorySections.mainTitle"
                                 :sectionsDisabled="true"/>
  </div>
</template>

<script>
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';

export default {
  name: 'CashflowTypeEconomy',
  components: {
    ExpenseProgress,
    PredictedCategorySections,
  },
  computed: {
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'יצא עד עכשיו',
          recommendedLabel: 'סה"כ צפוי לצאת',
        },
        categorySections: {
          mainTitle: 'פירוט הוצאות סופר',
        },
        cardTitle: 'הוצאות סופר',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-economy {
    @include cashflow-card;

    .title {
      @include cashflow-card-title;
    }

    .cashflow-type-color {
      color: $riseup_blue;
    }
  }

</style>
